import React, {Fragment} from 'react';
import PageTitle from '../../../Layout/AppMain/PageTitle';
import Tabs from 'react-responsive-tabs';

import Alumnos from './component/Alumnos';

export default class AlumnosComponent extends React.Component {

    render() {

        return (
            <Alumnos/>
        );
    }
}


// WEBPACK FOOTER //
// src/Pages/Demografico/Alumnos/index.js